/* import __COLOCATED_TEMPLATE__ from './office-address.hbs'; */
import { tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
@tagName('')
export default class SharedOfficeAddress extends Component {}
